import { ReadMoreModel } from '@_types/organisms';
import RequireCss from '@helpers/RequireCss';
import RequireJs from '@helpers/RequireJs';
import { getModifiers } from '@helpers/functions';
import Button from '@atoms/buttons/Button';
import Icon from '@atoms/icons/Icon';

interface Props extends ReadMoreModel {
  children?: React.ReactNode;
  contentClass?: string;
}

export default function ReadMore(model: Props) {
  const {
    collapsedText,
    content,
    expandedText,
    expandedOnLoad,
    children,
    maximumSeeMoreFullyLoadedQuantity,
    itemPerBatch,
    itemClassIdentify,
    contentClass = '',
    signpostingButton,
    expandedAllOnDesktop,
    showFirstBatchOnLoad,
    icon,
  } = model;
  const styleModifier = getModifiers(model, 'kf-o-read-more') + (expandedOnLoad ? ' active' : '');

  return (
    <div
      className={styleModifier}
      data-expanded-all-on-desktop={expandedAllOnDesktop}
      data-expanded-on-load={expandedOnLoad}
      data-item-class-identify={itemClassIdentify}
      data-item-first-batch-mobile={itemPerBatch?.mobileFirstBatch}
      data-item-first-batch-tablet={itemPerBatch?.tabletFirstBatch}
      data-item-per-batch-desktop={itemPerBatch?.desktop}
      data-item-per-batch-mobile={itemPerBatch?.mobile}
      data-item-per-batch-tablet={itemPerBatch?.tablet}
      data-maximum-see-more-fulled-loaded-quantity={maximumSeeMoreFullyLoadedQuantity}
      data-show-first-batch-on-load={showFirstBatchOnLoad}
    >
      {content && (
        <div className="kf-o-read-more__content-container">
          <div dangerouslySetInnerHTML={{ __html: content }} className={`kf-o-read-more__content ${contentClass}`} />
        </div>
      )}
      {children && (
        <div className="kf-o-read-more__content-container">
          <div className={`kf-o-read-more__content ${contentClass}`}>{children}</div>
        </div>
      )}
      <div aria-label="expander" aria-pressed={expandedOnLoad ? 'true' : 'false'} className="kf-o-read-more__expander" role="button" tabIndex={0}>
        {icon ? (
          <Icon {...icon} className="kf-o-read-more__expander__trigger-icon" />
        ) : (
          <span className="kf-o-read-more__expander__trigger">
            <span />
            <span />
          </span>
        )}
        <span className="kf-o-read-more__expander__text" data-collapse-text={collapsedText} data-expand-text={expandedText}>
          {expandedOnLoad ? collapsedText : expandedText}
        </span>
      </div>

      {signpostingButton && (
        <div className="kf-o-read-more__signposting-button">
          <Button {...signpostingButton} />
        </div>
      )}

      <RequireJs defer path="read-more" />
      <RequireCss path="b-read-more" />
    </div>
  );
}
